module.exports = __webpack_public_path__ + "static/knot-440b5223f7ac0ed0e40033da110462b6.svg";